// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { DataGridComponent } from './data-grid.component';
import { FilterSelectorModule } from 'ecova-filter-selector';

// 3rd Party
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    DataGridComponent
  ],
  imports: [
    // Angular
    CommonModule,

    // Components
    FilterSelectorModule,

    // 3rd party
    NgxDatatableModule
  ],
  exports:[
    DataGridComponent
  ]
})
export class DataGridModule { }
